export default __webpack_public_path__ + "static/media/question_mark.a488d751.svg";